import React, { useState, useEffect, useCallback, useContext, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import AlertContext from '../../../GlobalComponents/Alert/contexts/alertContext';
import AddProcessModal from '../../../AdminPages/Procesos/AgregarProceso';
import { ObtenerVacantesCompleto } from '../../../../servicios/ServicioVacante';
import { ObtenerUsuarios } from '../../../../servicios/ServicioUsuario';
import { ObtenerEstadosCompleto } from '../../../../servicios/ServicioEstados';
import { ObtenerObservaciones } from '../../../../servicios/ServicioObservacion';
import { ObtenerPorVacanteUsuario } from '../../../../servicios/ServicioProcesos';
import { Disclosure } from '@headlessui/react'


//import global components
import { Card, Modal, Table } from '../../../../imports';


//import services
import { AgregarObservacion } from '../../../../servicios/ServicioObservacion';


//import icons from heroicons
import { PlusCircleIcon, XMarkIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useLoader } from '../../../../context/LoaderContext.';
export default function Observacion({ validationMessages, idCurriculum, showProcess }) {

    //use alert context
    const alertCtx = useContext(AlertContext);


    const [listObservaciones, setListObservaciones] = useState([]);
    const [listProcesosByPerson, setListProcesosByPerson] = useState([]);
    const [listVacantes, setListVacantes] = useState([]);
    const [listUsuarios, setlistUsuarios] = useState([]);
    const [listEstados, setListEstados] = useState([]);
    const [listProcesos, setListProcesos] = useState([]);
    const [currentIdCard, setCurrentIdCard] = useState(null);
    const { showLoader, hideLoader } = useLoader();

    const { register, reset, getValues, watch, setValue, handleSubmit, formState } = useForm({
        mode: 'all'
    });
    //use to get validations from props and later iterate
    const [validations, setValidations] = useState([]);
    const { errors } = formState;
    const [showModal, setShowModal] = useState(false);
    const [showAddProcessModal, setShowAddProcessModal] = useState(false);

    //use modal and show for save
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [actionTypeConfirmModal, setActionTypeConfirmModal] = useState("");
    const [showAddModal, setShowAddModal] = useState(false);
    // const data = useMemo(() => [...listObservaciones], [listObservaciones]);

    const [idFromCard, setIdFromCard] = useState(0);
    const [newObservation, setNewObservation] = useState("");
    //validate if user already complete cv
    const userCompleteCV = sessionStorage.getItem("USER_COMPLETE_CV");
    async function getprocesos() {
        const data = {
            vacante: 0,
            usuario: idCurriculum
        }
        const response = await ObtenerPorVacanteUsuario(data);
        setListProcesosByPerson(response);
        if (Array.isArray(response)) {
            const updatedList = response.map((item) => {
                const dataForGlobalList = {
                    idUsuario: item?.idUsuario,
                    idProceso: item?.idProceso
                };

                return {
                    "dataHeader": {
                        "Descripción de la vacante": item?.descripcion,
                    },
                    "dataBody": {
                        "Estado": item?.estado,
                        "Vacante": item?.vacante
                    },
                    "dataID": {
                        "idProceso": item?.idProceso
                    },
                    "dataForGlobalList": dataForGlobalList
                };
            });

            setListProcesos(updatedList);
        }
    }

    async function getTechnologies() {

        const response = await ObtenerVacantesCompleto();

        setListVacantes(response);
    }


    async function getUsuarios() {
        const response = await ObtenerUsuarios();
        setlistUsuarios(response);
    }

    async function getEstados() {
        const response = await ObtenerEstadosCompleto();
        setListEstados(response);
    }

    useState(() => {
        showLoader();
        getTechnologies();
        getUsuarios();
        getEstados();
        getObservationsByPerson();
        hideLoader();
    }, [])

    async function getObservationsByPerson() {
        const response = await ObtenerObservaciones(idCurriculum);
        if (response) {
            setListObservaciones(response);
        } else {
            console.error("La respuesta no contiene un array válido:", response);
        }
    }
    const optionslistVacantes = listVacantes?.map(option => ({
        value: option.idVacante,
        label: option.descripcion
    }));

    const optionslistUsuarios = listUsuarios
        .map(option => ({
            value: option.idPersona,
            label: option.nombres
        }));

    const optionslistEstado = listEstados?.map(option => ({
        value: option.idEstado,
        label: option.descripcion
    }));

    const agregarObservacion = () => {
        if (!newObservation.trim()) {
            alert("Por favor, escribe una observación antes de guardarla.");
            return;
        }
        AgregarObservacionPersona(newObservation);

        setNewObservation("");
    };

    function setValuesById(list) {

        setValue("idPersona", list.
            ForGlobalList.idPersona)
        setValue("idProceso", list.dataForGlobalList.idProceso)


    }
    const customObjectByPersonList = useCallback(() => {
        if (Array.isArray(listProcesosByPerson)) {
            const updatedList = listProcesosByPerson.map((item) => {
                const dataForGlobalList = {
                    idUsuario: item?.idUsuario,
                    idProceso: item?.idProceso
                };

                return {
                    "dataHeader": {
                        "Descripción de la vacante": item?.descripcion,
                    },
                    "dataBody": {
                        "Estado": item?.estado,
                        "Vacante": item?.vacante
                    },
                    "dataID": {
                        "idProceso": item?.idProceso
                    },
                    "dataForGlobalList": dataForGlobalList
                };
            });

            setListProcesos(updatedList);
        }
    }, [listProcesosByPerson]);

    useState(() => {
        setValidations(validationMessages);
        getprocesos();
    }, [])
    useEffect(() => {
       // customObjectByPersonList
    }, [listProcesosByPerson]);

    async function filtrar() {

        const data = {
            vacante: 0,
            usuario: idCurriculum
        }
        const response = await ObtenerPorVacanteUsuario(data);

        setListProcesosByPerson(response);
    };
    //method to add new project
    const AgregarObservacionPersona = async (observacion) => {
        const userData = JSON.parse(sessionStorage.getItem("USER_DATA"));
        const observacionData = {
            observacion: observacion,
            idPersona: idCurriculum,
            usuario: userData ? userData.Correo : null
        };

        try {
            // Llamada al servicio para agregar la observación
            const observacionResponse = await AgregarObservacion(observacionData);

            if (observacionResponse.indicador === 0) {
                // Muestra el mensaje de éxito usando el contexto de alertas
                alertCtx.success(observacionResponse.mensaje);
                getObservationsByPerson();
               // setShowConfirmSaveModal(false);  // Cerrar el modal si está abierto
            } else {
                // Manejo de error si el indicador no es 0
                alertCtx.error(observacionResponse.mensaje);
            }
        } catch (error) {
            // Manejo de errores si falla la llamada al API
            alertCtx.error("Hubo un error al agregar la observación.");
            console.error(error);
        }
    };


    const columns = [
        {
            name: 'Observación',
            selector: row => row?.observacion,
        }
    ]

    const AddObservacionComponent = ({ onAddComment }) => {
        return (
            <div className="space-y-4 w-96 container mx-auto items-center justify-center">
                {/* Icono y Título */}
                <div className="flex flex-col items-center">
                    <PlusCircleIcon className="w-8 h-8 text-green-500" />
                    <h1 className="text-base font-bold leading-tight tracking-tight text-black-RS">
                        Añadir una observación
                    </h1>
                </div>

                {/* Campo de Texto y Botón */}
                <form
                    className="flex flex-col space-y-4"
                    onSubmit={(e) => {
                        e.preventDefault();
                        onAddComment(); // Llama a la función para manejar la observación
                    }}
                >
                    <textarea
                        name="observacion"
                        {...register("observacion", { required: true, maxLength: 200, minLength: 20 })}
                        id="observacion"
                        className="text-gray-900 sm:text-sm block w-full p-2.5 rounded border-solid border-2 border-grayDark-RS"
                        placeholder="Escriba su observación"
                        rows="8"
                        cols="70"
                    />
                    {/* Validaciones */}
                    {validations.observacion?.map((values) => (
                        errors.observacion?.type === values.type && (
                            <span key={values.type} className="text-sm font-bold text-red-RS">
                                {values.message}
                            </span>
                        )
                    ))}

                    {/* Botón de Agregar */}
                    <button
                        type="submit"
                        className="w-full bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 transition duration-150"
                    >
                        Agregar Observación
                    </button>
                </form>
            </div>
        );
    };


    return (
        <div className="w-full flex flex-col md:flex-row items-center justify-center px-1 mx-auto lg:py-0">
            {/* Block to manage form input 'proyectos' */}
            <div className={userCompleteCV === "false" ? "w-full pt-1 bg-white rounded-lg shadow" : "w-full pt-1"}>
                <div className="relative container mx-auto items-center justify-center">


                    {/* Contenedor flex para título y botón */}
                    <div className="flex justify-between items-center w-full">
                        <div className="flex justify-end items-center w-full mb-4">

                            {/*<button*/}
                            {/*    type="button"*/}
                            {/*    onClick={() => { setShowAddModal(!showAddModal); setValue("observacion", "") }}*/}
                            {/*    className="bg-grayDark-RS hover:bg-primary-700 text-white text-sm py-2 px-4 mx-2 font-medium rounded-lg inline-flex items-center text-center">*/}
                            {/*    <span>Observación</span>*/}
                            {/*    <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>*/}
                            {/*</button>*/}
                            {showProcess &&
                                <button
                                    type="button"
                                    onClick={() => { setShowAddProcessModal(!showAddProcessModal) }}
                                    className="bg-greenButton hover:bg-primary-700 text-white text-sm py-2 px-4 font-medium rounded-lg inline-flex items-center text-center">
                                    <span>Proceso de vacante</span>
                                    <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                </button>}
                        </div>
                    </div>


                    {/*Procesos*/}
                    {showProcess &&
                        <Disclosure className=" border">
                            {({ open }) => (
                                <>
                                    <Disclosure.Button className="flex w-full justify-between px-2 py-4 text-left text-base font-sans text-black-RS border-b-2 border-t-0 border-l-0 border-r-0 border-grayDark-RS hover:bg-grayLight-RS focus:outline-none focus-visible:ring focus-visible:ring-bg-Dark-RS focus-visible:ring-opacity-75">
                                        <span className="font-bold">Procesos de vacantes</span>
                                        <ChevronUpIcon
                                            className={`${open ? 'rotate-180 transform' : ''
                                                } h-5 w-5 text-black-RS`}
                                        />
                                    </Disclosure.Button>
                                    <Disclosure.Panel className="px-4 ml-2  pt-4 pb-2 text-sm text-black-RS">
                                        {listProcesos?.length > 0 &&
                                            <div className="container flex flex-wrap w-full py-4 mt-6 mx-auto items-start justify-center">
                                                {/*iterate over list techs */}
                                                {listProcesos?.map((item, index) => (

                                                    <div className="w-full m-1 p-1 mt-8 py-6 md:w-96" key={index}>
                                                        <Card
                                                            id={index}
                                                            data={item}
                                                            list={listProcesos}
                                                            setList={setListProcesos}
                                                            setCurrentIdCard={setCurrentIdCard}
                                                            setShowModal={setShowModal}
                                                            setValuesById={setValuesById}
                                                            allowEdit={true}
                                                            listByPerson={listProcesosByPerson}
                                                            userCompleteCV={userCompleteCV}
                                                            deleteElementCV={null}
                                                            setActionTypeConfirmModal={setActionTypeConfirmModal}
                                                            title="Procesos de vacantes"
                                                        />
                                                    </div>
                                                ))}
                                            </div>}
                                    </Disclosure.Panel>
                                </>
                            )}
                        </Disclosure>
                    }
                    {/*Observaciones*/}
                    <Disclosure className="border">
                        {({ open }) => (
                            <>
                                <Disclosure.Button className="flex w-full justify-between px-2 py-4 text-left text-base font-sans bg-white text-black-RS border-b-2 border-t-0 border-l-0 border-r-0 border-grayDark-RS focus:outline-none focus-visible:ring focus-visible:ring-bg-Dark-RS focus-visible:ring-opacity-40">
                                    <span className="font-bold">Observaciones</span>
                                    <ChevronUpIcon
                                        className={`${open ? "rotate-180 transform" : ""} h-5 w-5 text-black-RS`}
                                    />
                                </Disclosure.Button>
                                <Disclosure.Panel className="px-4 ml-2 pt-4 pb-2 text-sm text-black-RS">
                                    <div>
                                       
                                        <div className="flex justify-center items-center h-full">
                                            <textarea
                                                name="observacion"
                                                id="observacion"
                                                value={newObservation}
                                                onChange={(e) => setNewObservation(e.target.value)}
                                                className="text-gray-900 sm:text-sm block w-full mx-4 rounded border-solid border-2 border-grayDark-RS"
                                                rows="3"
                                                placeholder="Agrega una nueva observación"
                                            />
                                            <button
                                                className="bg-green-500 text-white py-2 px-4 w-40 rounded hover:bg-green-600 transition duration-150 inline-flex items-center"
                                                onClick={agregarObservacion}
                                            >
                                                <span> Agregar</span>
                                               
                                                <PlusCircleIcon className="w-8 h-8 ml-2"></PlusCircleIcon>
                                            </button>
                                        </div>
                                        <>
                                            <Table
                                                title="Observaciones"
                                                filteredItems={""}
                                                filterBy="observacion"
                                                columns={columns}
                                                data={listObservaciones}
                                                mostrarBuscar={false }
                                            />
                                        </>                                       
                                    </div>
                                </Disclosure.Panel>
                            </>
                        )}
                    </Disclosure>


                    {/*Here we show add modal compononent*/}
                    {/*<Modal isVisible={showAddModal} onClose={() => { setShowAddModal(false) }} handleSubmit={handleSubmit} onSaveOptions={onSaveAddOptions} showCloseIcon={false}>*/}
                    {/*    Button to close modal*/}
                    {/*    <div className="flex justify-end m-2">*/}
                    {/*        <button className="cursor-pointer text-black-400 hover:text-gray-600 transition duration-150 ease-in-out rounded ring-2 focus:outline-none ring-gray-600" onClick={() => setShowAddModal(false)} aria-label="close modal" role="button">*/}
                    {/*            <XMarkIcon className="text-red-RS h-6 w-6" />*/}
                    {/*        </button>*/}
                    {/*    </div>*/}
                    {/*    <AddObservacionComponent />*/}
                    {/*</Modal>*/}

                </div>
            </div>
            <AddProcessModal
                showAddModal={showAddProcessModal}
                setShowAddModal={setShowAddProcessModal}
                validations={validations}
                errors={errors}
                optionslistVacantes={optionslistVacantes}
                optionslistUsuarios={optionslistUsuarios}
                optionslistEstado={optionslistEstado}
                idCurriculum={idCurriculum}
                filtrar={filtrar}
            />
        </div >

    );
}
